import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { SchedulerLayout } from "../SchedulerLayout";
import { SchedulerRouterProps } from "../SchedulerRouterProps";

interface HomePageProps extends NSARouterMakerResult, SchedulerRouterProps { }

class HomePage extends Component<HomePageProps>
{
    override render()
    {
        return (
            <SchedulerLayout {...this.props}>
                <NSAHomePage {...this.props} />
            </SchedulerLayout>
        )
    }
}

export default HomePage;